




















































































































































































































import { PropType } from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import mixins from '@/utils/mixins';
import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';

import {
  IQuoteTermItemData,
  IQuoteTermTemplate,
  QuoteTermItem,
  QuoteTermTemplate
} from '@/models';

import { ErrorHandler } from '@/models/errors';
import { omit } from 'lodash';

import QuillPDFEditor from '../common/QuillPDFEditor.vue';
import QuoteTemplateNoteDropDownItem from './section/QuoteTemplateNoteDropDownItem.vue';

const baseMixins = mixins(BindsAttrs, Validatable);

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $_modelEvent: string;
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuotesTermItemsSection',

    components: { QuillPDFEditor, QuoteTemplateNoteDropDownItem },

    props: {
      editable: Boolean,

      language: {
        type: String
      },

      errors: {
        type: Object as PropType<ErrorHandler>
      },

      organization: {
        type: Number,
        required: true
      }
    },

    data: () => ({
      selectedTerm: null as null | number,
      termsLoading: false
    }),

    watch: {
      internalValue: {
        handler() {
          this.validate();
        },
        deep: true
      }
    },

    computed: {
      quoteTermTemplates: get<IQuoteTermTemplate[]>(
        'quoteTemplate/getQuoteTermTemplates'
      ),

      requiredRule() {
        return (field: string) => [
          (v: string) => !!v || `${field} is required`
        ];
      },

      canAddAllTerms(): boolean {
        return this.internalValue.length < 1;
      }
    },

    async mounted() {
      await this.$nextTick(async () => {
        await this.fetchTerms();
      });
    },

    beforeCreate() {
      // v-radio-group needs to emit a different event
      // https://github.com/vuetifyjs/vuetify/issues/4752
      this.$_modelEvent =
        (this.$options.model && this.$options.model.event) || 'input';
    },

    methods: {
      ...mapActions({
        fetchQuoteTermTemplates: 'quoteTemplate/fetchQuoteTermTemplates'
      }),

      fetchTerms() {
        return this.fetchQuoteTermTemplates({
          organization: this.organization
        });
      },

      async addTermItem() {
        this.setTerm(new QuoteTermTemplate(), this.internalValue.length);
      },

      async addTermItems() {
        this.termsLoading = true;
        await this.fetchTerms()
          .then(() => {
            this.quoteTermTemplates.forEach(this.setTerm);
          })
          .finally(() => {
            this.termsLoading = false;
          });
      },

      removeTermItem(item: IQuoteTermTemplate, index?: number) {
        const itemIndex = index ?? this.internalValue.indexOf(item);
        this.internalValue.splice(itemIndex, 1);
      },

      setTerm(value: IQuoteTermTemplate, index: number) {
        const termItemData: IQuoteTermItemData = {
          template: value['id']!,
          order: this.internalValue.length + 1,
          ...omit(value, ['id'])
        };
        //https://vuejs.org/v2/guide/reactivity.html#For-Arrays.
        this.$set(this.internalValue, index, new QuoteTermItem(termItemData));

        this.selectedTerm = null;
      },

      clearSelectedValue(index: number) {
        this.internalValue[index].id = null;
        this.internalValue[index].template = null;
        this.internalValue[index].title = '';
        this.internalValue[index].description = '';
      },

      textChanged(index: number) {
        this.internalValue[index].template = null;
      }
    }
  });
